module.exports = __webpack_public_path__ + "static/img/BaileySmith.f8375d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BaileySmith.jpg
// module id = i0V2
// module chunks = 0